<!-- This example requires Tailwind CSS v2.0+ -->
<template>

  <div class="fixed bottom-24 right-1 lg:right-4 p-4 bg-white border-t-4 shadow-lg" style="z-index: 10000;"  v-if="this.open === true">
    <h2 class="text-lg lg:text-xl mb-4 block font-bold leading-tight text-gray-600">Cookie Policy</h2>
    <div class="lg:flex lg:space-x-5">
      <p class="mb-5 font-medium text-gray-600">
        We and selected partners and related companies, use cookies and similar technologies as
        specified in our Cookies Policy. You agree to consent to the use of these technologies by
        clicking Accept, or by continuing to browse this website. You can learn more about how we
        use cookies and set cookie preferences in Settings.
      </p>
      <button @click="acceptCookie()"
          class="w-full lg:w-48 px-3 py-1 bg-gray-300 hover:bg-gray-200 hover:underline rounded text-gray-700 mr-2 mb-5 uppercase tracking-widest text-xs font-bold">
        I agree
      </button>
    </div>
  </div>
</template>

<script>
import {SpeakerphoneIcon, XIcon} from '@heroicons/vue/outline'
import {ref} from "vue";

export default {
  components: {
    SpeakerphoneIcon,
    XIcon,
  },

  created() {
    this.ifAccept();
  },
  setup() {
    const open = ref(true)

    return {
      open,
    }
  },
  methods: {
    acceptCookie() {
      window.localStorage.setItem('accept_cookie', 1);
      this.open = false;
    },
    ifAccept() {
      this.open = window.localStorage.getItem('accept_cookie') != 1;
    }
  }

}
</script>
